// Libs
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

// Components
import { BlogCard } from "../../components/BlogCard/BlogCard";
import { LoadingFallback } from "../../components/LoadingFallback/LoadingFallback";
import { View } from "../../containers/view/View";

// Utils
import { Blog } from "../../models/Blog";
import OpenIcon from "@mui/icons-material/OpenInNewTwoTone";

import api from "../../api";
import styles from "./ServicesPage.module.scss";
import { previewImage } from "../../constants";

export const ServicesPage: React.FunctionComponent = () => {
  const [posts, setPosts] = useState<Blog[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchPosts = async () => {
    setLoading(true);
    try {
      const response = await api.blogs.fetchBlogs("7");
      const data = await response.json();
      if (response.status === 200) {
        setPosts(data);
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  return (
    <View
      title="Tražite radnike"
      description="Ukoliko ste u potrazi za radnicima, našim klijentima nudimo usluge posredovanje pri zapošljavanju, oglašavanja na portalu otvorenih radnih mjesta, kao i ustupanje ljudskih resursa na privremenoj i povremenoj osnovi."
    >
      <Helmet>
        <title>Tražite radnike | Agencija Spektar</title>
        <meta name="description" content="Agencija Spektar" />
        <meta
          property="og:title"
          content="Tražite radnike | Agencija Spektar"
        />
        <meta property="og:image" content={previewImage} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Agencija Spektar" />
      </Helmet>

      <View.Content style={{ marginBottom: "15vh" }}>
        <div className={styles.cards}>
          {loading && <LoadingFallback />}
          {!loading && posts.length === 0 ? (
            <p className={styles.text}>Nisu pronađeni članci.</p>
          ) : (
            posts.map((e) => {
              return <BlogCard blog={e} key={e.id} />;
            })
          )}
        </div>
        <div className={styles.section}>
          <div className={styles.templates}>
            <a
              href="https://test.agencijaspektar.com:9000/katalozi/Katalogusluga.pdf"
              target="_blank"
              rel="noreferer"
            >
              Katalog usluga <OpenIcon />
            </a>
            <a
              href="https://test.agencijaspektar.com:9000/katalozi/ServicesCatalog.pdf"
              target="_blank"
              rel="noreferer"
            >
              Services Catalog <OpenIcon />
            </a>
          </div>
        </div>
      </View.Content>
    </View>
  );
};
